export const environment = {
  env: 'homolog',
  production: true,
  legacy: {
    baseUrl: '',
  },
  back: {
    baseUrl: `https://pass.homolog.bodytech.company/api`,
  },
  fariaLimaId: 34,
  sentry: {
    dsn: 'https://5e817bf5ea834ad390009869cee2c08e@sentry.dev.bodytech.company/2',
    enabled: true,
    environment: 'homolog',
    release: 'btpass-042a7ac',
    attachStacktrace: true,
  },
};
